import {environment} from '../../../environments/environment';

export abstract class BaseService {
  protected baseUrl: string;

  protected constructor() {
    this.baseUrl = `${environment.apiUrl}/${environment.apiVersion}`;
  }
}



